/**
 * Author: Lakshman Veti
 * Type: Configuration
 * Objective: To access global variables accross application
 * Usage: Accross application
 */

 var configuration = {
  appName: "iSPS",
  //apiUrl: "http://119.73.180.162:8081/",
  apiUrl: "https://isps.cosulich.com.sg:8081/",
  clientName:'Fratelli',
  snapshot: {
    login: "iPMS-Login-0.0.1-SNAPSHOT",
    dashboard: "iPMS-Dashboard-0.0.1-SNAPSHOT",
    requisition: "iPMS-Requisition-0.0.1-SNAPSHOT/requisition",
    reports: "iPMS-Reports-0.0.1-SNAPSHOT",
    poAnalysisReports: "iPMS-Reports-0.0.1-SNAPSHOT",
    requisitionDocuments: "iPMS-Requisition-0.0.1-SNAPSHOT/documents",
    auditLogs:"iPMS-Requisition-0.0.1-SNAPSHOT/AuditLogs",
    supplierQuotation: "iPMS-Quotation-0.0.1-SNAPSHOT/quotation",
    documents: "iPMS-Docuemnts-0.0.1-SNAPSHOT/documents",
    deliveryOrder: "iPMS-Delivery-Order-0.0.1-SNAPSHOT/deliveryOrder",
    updateDOPostingInfo:"iPMS-Delivery-Order-0.0.1-SNAPSHOT/deliveryOrder/updateDOPostingInfo",
    verifiedDoEmail: "iPMS-Delivery-Order-0.0.1-SNAPSHOT/deliveryOrder/verifiedEmailSend",
    purchaseOrder: "iPMS-PurchaseOrder-0.0.1-SNAPSHOT",
    delieveryOrder: "iPMS-Delivery-Order-0.0.1-SNAPSHOT",
    quotationCompare: "iPMS-Quotation-0.0.1-SNAPSHOT/quotationCompare",
    master: "iPMS-Master-0.0.1-SNAPSHOT",
    getAllMasters: "iPMS-Master-0.0.1-SNAPSHOT/masterMaintenance/getAllMastersList/",
    getAllActiveMasters: "iPMS-Master-0.0.1-SNAPSHOT/masterMaintenance/getAllActiveMastersList/",
    contractcategory: "iPMS-Master-0.0.1-SNAPSHOT/contractcategory/getAllPMSContractCategories/",
    saveUpdateDeleteMasterInfo: "iPMS-Master-0.0.1-SNAPSHOT/masterMaintenance/saveUpdateDeleteMasterInfo/",
    getMasterRecord:"iPMS-Master-0.0.1-SNAPSHOT/masterMaintenance/getMasterInfoById/",
    master_price_list: "iPMS-Master-Price-List-0.0.1-SNAPSHOT",
    mainCodes: "iPMS-Master-0.0.1-SNAPSHOT/maincode/getAllMainCodes",
    master_list_qoutation: "iPMS-Master-List-Quotation-0.0.1-SNAPSHOT",
    currencyList: "iPMS-Master-0.0.1-SNAPSHOT/currency/getAllCurrency",
    vendorList: "iPMS-Master-0.0.1-SNAPSHOT/vendor/getAllVendors",
    qrCode: "iPMS-Docuemnts-0.0.1-SNAPSHOT/documents/generateQRCodeImage",
    approval_center: "iPMS-ApprovalProcess-0.0.1-SNAPSHOT",
    printPO:
      "iPMS-PurchaseOrder-0.0.1-SNAPSHOT/purchaseOrderReport/printPOReport",
    bargeList: "iPMS-Master-0.0.1-SNAPSHOT/barge/getAllBarges",
    equipmentList: "iPMS-Master-0.0.1-SNAPSHOT/equipment/getAllEquipments",
    impaCodeList: "iPMS-Master-0.0.1-SNAPSHOT/impacode/getAllIMPACodes",
    impaCategoryList: "iPMS-Master-0.0.1-SNAPSHOT/impacategory/getAllIMPACategorys",
    orderTypeList: "iPMS-Master-0.0.1-SNAPSHOT/pmsordertyp/getAllPmsOrderTypes",
    portList: "iPMS-Master-0.0.1-SNAPSHOT/port/getAllPorts",
    employeeList: "iPMS-Master-0.0.1-SNAPSHOT/employee/getAllEmployees",
    uomCodeList: "iPMS-Master-0.0.1-SNAPSHOT/uom/getAllUOMs",
    vesselDepartmentList:
      "iPMS-Master-0.0.1-SNAPSHOT/admvesseldepartment/getAllVesselDepartments",
    sparePartList: "iPMS-Master-0.0.1-SNAPSHOT/sparePart/getAllSpareParts",
    modelList: "iPMS-Master-0.0.1-SNAPSHOT/sparesModel/getAllSparesModels",
    contactPersonList: "iPMS-Master-0.0.1-SNAPSHOT/vendor/getAllVendorPICs",
    submitPR: "iPMS-Requisition-0.0.1-SNAPSHOT/requisition/submitConfirmation",
    submitSQ: "iPMS-Quotation-0.0.1-SNAPSHOT/quotation/submitConfirmation",
    submitDO:
      "iPMS-Delivery-Order-0.0.1-SNAPSHOT/deliveryOrder/submitConfirmation",
    submitPO:
      "iPMS-PurchaseOrder-0.0.1-SNAPSHOT/purchaseOrder/submitConfirmation",
    oauth: "http://15.206.125.60:9191/oauth/token",
    changeDOStatus: "/changeDeliveryOrderStatus",
    submitMLQ:
      "iPMS-Master-List-Quotation-0.0.1-SNAPSHOT/masterListQuotation/submitConfirmation",
    changePOStatus:
      "iPMS-PurchaseOrder-0.0.1-SNAPSHOT/purchaseOrder/changeStatus",
    checkReqAccess: "iPMS-Quotation-0.0.1-SNAPSHOT/quotation/getQuotationByRequisitionId",
    submitEVC: "iPMS-Master-Price-List-0.0.1-SNAPSHOT/employeeVendorClaims/submitEmployeeVendorClaimsConfirmation",
    submitECC: "iPMS-Master-Price-List-0.0.1-SNAPSHOT/employeeCashClaims/submitEmployeeCashClaimsConfirmation",
    systemSettings: "/login/GetSystemSettings",
    poAnalysis:"iPMS-PurchaseOrder-0.0.1-SNAPSHOT/purchaseOrder/POAnalysis",
    tokenGenerate: "iPMS-Master-0.0.1-SNAPSHOT/authenticate",
  },
  appSetting: {
    headingDateFormat: "DD-MMM-YYYY",
    globelDateFormat: "DD/MM/YYYY",
    dashboardDefaultRange: "Year",
  },
};

module.exports = configuration;
